export default "__VITE_ASSET__INSWPRXy__"